import(/* webpackMode: "eager" */ "/var/www/voiceagent-app/RestroAgent/src/app/(landing)/faq/page.tsx");
